// Spawn normalization target: every model's largest dimension is fit to this (a coke can).
// Instance scale=1 means "coke-can size"; rendered max extent = COKE_CAN_SIZE * instance.scale.
export const COKE_CAN_SIZE = 0.12
